import {
    NOTIFICATION_STATE_KEY,
    REQUEST_LOADING_INDICATOR_STATE_KEY,
    SURVEYS_FEATURE_KEY,
} from '../../constants/state-keys';
import { NotificationState } from './NotificationState.interface';
import { RequestLoadingIndicatorState } from './RequestLoadingIndicatorState.interface';
import { ISurveysFeatureState } from './surveys-feature-state.interface';

export interface CoreCombinedReducersInterface {
    [NOTIFICATION_STATE_KEY]: NotificationState;
    [REQUEST_LOADING_INDICATOR_STATE_KEY]: RequestLoadingIndicatorState;
    [SURVEYS_FEATURE_KEY]: ISurveysFeatureState;
}
